import DrawerGroup from './Group';
import DrawerItem from './Item';

const Drawer = {
  Group: DrawerGroup,
  Item: DrawerItem,
};

export default Drawer;
